import { DetailedHTMLProps, InputHTMLAttributes } from 'react';
import { IsVisible } from '../../../utils';
import { FieldBase, IFieldBaseProps } from '../Base';
import { numberFieldStyles } from './styles';

export interface INumberFieldProps
  extends DetailedHTMLProps<
    Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>,
    HTMLInputElement
  > {
  containerProps?: IFieldBaseProps;
  endAdornment?: React.ReactNode;
  startAdornment?: React.ReactNode;
}

export function NumberField({
  className = '',
  containerProps,
  disabled = false,
  endAdornment,
  name,
  readOnly = false,
  startAdornment,
  ...rest
}: INumberFieldProps): JSX.Element {
  return (
    <FieldBase {...containerProps}>
      <div className={numberFieldStyles.container()}>
        <IsVisible when={!!startAdornment}>
          <div
            aria-hidden="true"
            className={numberFieldStyles.startAdornment()}
          >
            {startAdornment}
          </div>
        </IsVisible>
        <input
          className={numberFieldStyles.input({
            disabled: disabled || readOnly,
            startAdornment: !!startAdornment,
            endAdornment: !!endAdornment,
            className,
          })}
          disabled={disabled}
          name={name}
          readOnly={readOnly}
          type="number"
          {...rest}
        />
        <IsVisible when={!!endAdornment}>
          <div aria-hidden="true" className={numberFieldStyles.endAdornment()}>
            {endAdornment}
          </div>
        </IsVisible>
      </div>
    </FieldBase>
  );
}
